export enum CHANNELS {
  SYSTEM = "system",
  SERIES_UPDATES = "series_updates",
  MATCH_UPDATES = "match_updates",
  ODDS_MARKET_UPDATES = "odds_market_updates",
}
